export default __webpack_public_path__ + "static/media/card1@3x.5e151fe1.png";